/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Video action ad format configuration
 * @export
 * @interface VideoActionConfig
 */
export interface VideoActionConfig {
    /**
     * 
     * @type {string}
     * @memberof VideoActionConfig
     */
    videoAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof VideoActionConfig
     */
    videoUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof VideoActionConfig
     */
    requiredWatchPercent?: number;
    /**
     * 
     * @type {string}
     * @memberof VideoActionConfig
     */
    ctaAction?: string;
    /**
     * JSON config for the CTA action
     * @type {string}
     * @memberof VideoActionConfig
     */
    ctaConfig?: string;
}

/**
 * Check if a given object implements the VideoActionConfig interface.
 */
export function instanceOfVideoActionConfig(value: object): value is VideoActionConfig {
    return true;
}

export function VideoActionConfigFromJSON(json: any): VideoActionConfig {
    return VideoActionConfigFromJSONTyped(json, false);
}

export function VideoActionConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideoActionConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'videoAssetId': json['videoAssetId'] == null ? undefined : json['videoAssetId'],
        'videoUrl': json['videoUrl'] == null ? undefined : json['videoUrl'],
        'requiredWatchPercent': json['requiredWatchPercent'] == null ? undefined : json['requiredWatchPercent'],
        'ctaAction': json['ctaAction'] == null ? undefined : json['ctaAction'],
        'ctaConfig': json['ctaConfig'] == null ? undefined : json['ctaConfig'],
    };
}

export function VideoActionConfigToJSON(json: any): VideoActionConfig {
    return VideoActionConfigToJSONTyped(json, false);
}

export function VideoActionConfigToJSONTyped(value?: VideoActionConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'videoAssetId': value['videoAssetId'],
        'videoUrl': value['videoUrl'],
        'requiredWatchPercent': value['requiredWatchPercent'],
        'ctaAction': value['ctaAction'],
        'ctaConfig': value['ctaConfig'],
    };
}

